<template>
  <div class="shop-detail">
    <div class="nav">
      <div class="title" @click="$router.replace({ path: '/shop/list' });">商品详情</div>
    </div>

    <div class="content" v-if="product">
      <!-- 商品图片 -->
      <div class="product-gallery">
        <div class="main-image"
             @touchstart="handleTouchStart"
             @touchend="handleTouchEnd"
             @mousedown="handleMouseDown"
             @mouseup="handleMouseUp"
             @mousemove="handleMouseMove"
             @mouseleave="handleMouseLeave">
          <img :src="product.images && product.images[currentImageIndex] ? product.images[currentImageIndex] : product.image" :alt="product.name">
        </div>
        <div class="thumbnail-list">
          <div class="thumbnail"
               v-for="(img, index) in product.images"
               :key="index"
               :class="{ active: currentImageIndex === index }"
               @click="changeImage(index)">
            <img :src="img" :alt="`${product.name} ${index + 1}`">
          </div>
        </div>
      </div>

      <!-- 商品信息 -->
      <div class="product-info">
        <div class="product-title">
          <h1>{{ product.name }}</h1>
          <div class="product-tag" v-if="product.tag">{{ product.tag }}</div>
        </div>

        <div class="product-price">
          <span class="price-symbol">¥</span>
          <span class="price-value">{{ product.price }}</span>
          <span class="original-price" v-if="product.marketprice">¥{{ product.marketprice }}</span>
        </div>

        <div class="product-meta">
          <div class="meta-item">
            <span class="meta-label">销量</span>
            <span class="meta-value">{{ product.sales }}件</span>
          </div>
          <div class="meta-item">
            <span class="meta-label">浏览量</span>
            <span class="meta-value">{{ product.views }}次</span>
          </div>
          <div class="meta-item">
            <span class="meta-label">好评度</span>
            <span class="meta-value">{{ product.favor_rate }}%</span>
          </div>
        </div>

        <div class="product-images-detail" v-if="product.content">
          <h3>商品详情</h3>
          <div class="detail-content" v-if="product.content" v-html="product.content"></div>
        </div>
      </div>

      <!-- 底部购买栏 -->
      <div class="bottom-bar">
        <div class="bottom-bar-right">
          <button class="btn-buy" @click="showQRCode">立即购买</button>
        </div>
      </div>

      <!-- 购买二维码弹窗 -->
      <div class="qr-modal" v-if="showQRModal" @click="hideQRCode">
        <div class="qr-content" @click.stop>
          <div class="qr-title">扫码购买</div>
          <div class="qr-code">
            <div class="qr-image">
              <img v-if="qrCodeUrl" :src="qrCodeUrl" alt="购买二维码" style="width: 100%; height: 100%;">
            </div>
            <div class="qr-text">请使用手机扫描二维码完成购买</div>
          </div>
          <div class="qr-close" @click="hideQRCode">×</div>
        </div>
      </div>
    </div>

    <!-- 加载中状态 -->
    <div class="loading" v-else>
      <div class="loading-spinner"></div>
      <div class="loading-text">加载中...</div>
    </div>
  </div>
</template>

<script>
import idleDetection from '@/mixins/idleDetection';
import { getGoodsDetail, getWxCode } from '@/api/shop';
import { mapGetters } from "vuex";


export default {
  name: 'ShopDetail',
  mixins: [idleDetection],
  data() {
    return {
      productId: null,
      currentImageIndex: 0,
      showQRModal: false,
      showServiceModal: false,
      qrCodeUrl: '',
      product: null,
      startX: 0,
      isDragging: false,
      products: []
    }
  },
  computed: mapGetters(["userInfo"]),
  created() {
    this.productId = this.$route.params.id;
    this.loadProduct();
  },
  methods: {
    loadProduct() {
      getGoodsDetail({ id: this.productId }).then(res => {
        this.product = res.data;
      }).catch(() => {
        this.$toast('商品不存在或网络错误');
      });
    },
    changeImage(index) {
      this.currentImageIndex = index;
    },
    handleTouchStart(event) {
      this.startX = event.touches[0].clientX;
    },
    handleTouchEnd(event) {
      const endX = event.changedTouches[0].clientX;
      const deltaX = endX - this.startX;
      this.handleSwipe(deltaX);
    },
    handleMouseDown(event) {
      this.isDragging = true;
      this.startX = event.clientX;
    },
    handleMouseUp(event) {
      if (this.isDragging) {
        const endX = event.clientX;
        const deltaX = endX - this.startX;
        this.handleSwipe(deltaX);
      }
      this.isDragging = false;
    },
    handleMouseMove(event) {
      // 防止鼠标拖动时选中文字
      if (this.isDragging) {
        event.preventDefault();
      }
    },
    handleMouseLeave() {
      this.isDragging = false;
    },
    handleSwipe(deltaX) {
      if (!this.product || !this.product.images || this.product.images.length < 2) return;

      if (deltaX < -50) { // 向左滑动
        this.currentImageIndex = (this.currentImageIndex + 1) % this.product.images.length;
      } else if (deltaX > 50) { // 向右滑动
        this.currentImageIndex = this.currentImageIndex > 0 ? this.currentImageIndex - 1 : this.product.images.length - 1;
      }
    },
    showQRCode() {
      if (this.qrCodeUrl) {
        this.showQRModal = true;
        return;
      }
      if (!this.product || !this.product.id ) {
        this.$toast('商品信息加载失败');
        return;
      }
      const adminId = this.userInfo ? this.userInfo.id || '' : ''
      getWxCode({ goods_id: this.product.id, admin_id: adminId }).then(res => {
        this.qrCodeUrl = res.data || res.data.data;
        this.showQRModal = true;
      }).catch(error => {
        this.$toast('获取二维码失败');
        console.error('获取二维码错误:', error);
      });
    },
    hideQRCode() {
      this.showQRModal = false;
    },
    showService() {
      this.showServiceModal = true;
    },
    hideService() {
      this.showServiceModal = false;
    },
    addToFavorite() {
      this.$toast('已添加到收藏');
    }
  }
}
</script>

<style scoped lang="scss">
.shop-detail {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  padding: 70px 40px 0;
  display: flex;
  flex-direction: column;



  .nav {
    font-family: 'YouSheBiaoTiHei';
    color: #ffffff;
    font-weight: 400;
    font-size: 56px;
    margin-bottom: 45px;
    position: relative;

    .title {
      display: inline-block;
      padding: 12px 50px 0;
      cursor: pointer;

      &::before {
        content: '';
        width: 30px;
        height: 30px;
        border-top: 5px solid transparent;
        border-bottom: 5px solid #fff;
        border-right: 5px solid transparent;
        border-left: 5px solid #fff;
        position: absolute;
        top: 50%;
        left: 0;
        transform: rotate(45deg) translateY(-50%);
      }
    }
  }

  .content {
    flex: 1;
    background-color: #fff;
    border-radius: 20px;
    overflow-y: auto;
    overflow-x: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    margin-bottom: 20px;

    .product-gallery {
      .main-image {
        height: 1000px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .thumbnail-list {
        display: flex;
        padding: 20px;
        gap: 20px;
        overflow-x: auto;

        .thumbnail {
          flex-shrink: 0;
          width: 120px;
          height: 120px;
          border-radius: 10px;
          overflow: hidden;
          border: 2px solid transparent;
          cursor: pointer;

          &.active {
            border-color: #0066cc;
          }

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
    }

    .product-info {
      padding: 30px;

      .product-title {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        h1 {
          font-size: 44px;
          font-weight: 600;
          color: #333;
          margin: 0;
        }

        .product-tag {
          margin-left: 20px;
          padding: 10px 20px;
          background-color: #ff6b6b;
          color: #fff;
          font-size: 24px;
          border-radius: 25px;
        }
      }

      .product-price {
        display: flex;
        align-items: baseline;
        margin-bottom: 20px;

        .price-symbol {
          font-size: 36px;
          color: #ff6b6b;
        }

        .price-value {
          font-size: 64px;
          font-weight: 600;
          color: #ff6b6b;
          margin-right: 15px;
        }

        .original-price {
          font-size: 28px;
          color: #999;
          text-decoration: line-through;
        }
      }

      .product-meta {
        display: flex;
        margin-bottom: 20px;

        .meta-item {
          flex: 1;
          text-align: center;

          .meta-label {
            display: block;
            font-size: 26px;
            color: #999;
            margin-bottom: 5px;
          }

          .meta-value {
            font-size: 32px;
            font-weight: 600;
            color: #333;
          }
        }
      }

      .product-rating {
        display: flex;
        align-items: center;
        margin-bottom: 30px;

        .rating-stars {
          display: flex;
          margin-right: 15px;

          .star {
            width: 24px;
            height: 24px;
            margin-right: 5px;
            background-color: #ddd;
            clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);

            &.filled {
              background-color: #ffd700;
            }
          }
        }

        .rating-text {
          font-size: 28px;
          color: #333;
        }
      }

      .product-description {
        margin-bottom: 30px;

        h3 {
          font-size: 36px;
          font-weight: 600;
          color: #333;
          margin-bottom: 15px;
        }

        p {
          font-size: 28px;
          color: #666;
          line-height: 1.6;
        }
      }

      .product-features {
        margin-bottom: 30px;

        h3 {
          font-size: 36px;
          font-weight: 600;
          color: #333;
          margin-bottom: 15px;
        }

        ul {
          padding-left: 25px;

          li {
            font-size: 28px;
            color: #666;
            line-height: 1.6;
            margin-bottom: 10px;
            position: relative;

            &::before {
              content: '✓';
              color: #0066cc;
              font-weight: bold;
              position: absolute;
              left: -25px;
            }
          }
        }
      }

      .product-specs {
        margin-bottom: 30px;

        h3 {
          font-size: 36px;
          font-weight: 600;
          color: #333;
          margin-bottom: 15px;
        }

        .spec-item {
          display: flex;
          padding: 15px 0;
          border-bottom: 1px solid #eee;

          .spec-name {
            width: 150px;
            font-size: 28px;
            color: #999;
          }

          .spec-value {
            flex: 1;
            font-size: 28px;
            color: #333;
          }
        }
      }

      .product-images-detail {
        h3 {
          font-size: 36px;
          font-weight: 600;
          color: #333;
          margin-bottom: 15px;
        }

        .detail-content {
          margin-bottom: 30px;

          h1, h2, h3, h4, h5, h6 {
            font-size: 32px;
            font-weight: 600;
            color: #333;
            margin: 20px 0 10px;
          }

          p {
            font-size: 28px;
            color: #666;
            line-height: 1.6;
            margin-bottom: 15px;
          }

          img {
            max-width: 100%;
            height: auto;
            margin-bottom: 20px;
            display: block;
          }

          ul, ol {
            margin-bottom: 15px;
            padding-left: 30px;

            li {
              font-size: 28px;
              color: #666;
              line-height: 1.6;
              margin-bottom: 8px;
            }
          }

          table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 20px;

            th, td {
              border: 1px solid #eee;
              padding: 12px;
              font-size: 26px;
              color: #666;
            }

            th {
              font-weight: 600;
              background-color: #f9f9f9;
              color: #333;
            }
          }
        }

        .detail-image {
          margin-bottom: 20px;

          img {
            width: 100%;
            display: block;
          }
        }
      }
    }
  }

  .bottom-bar {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 140px;
    background-color: #fff;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    padding: 20px 40px;
    z-index: 100;
    display: flex;
    justify-content: center;
    align-items: center;

    .bottom-bar-left {
      display: flex;

      .service-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 40px;
        cursor: pointer;

        .iconfont {
          font-size: 44px;
          color: #666;
          margin-bottom: 5px;
        }

        span {
          font-size: 24px;
          color: #666;
        }
      }
    }

    .bottom-bar-right {
      display: flex;

      button {
        height: 80px;
        border: none;
        border-radius: 40px;
        font-size: 32px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s ease;

        &.btn-add-cart {
          width: 220px;
          background-color: #ff9500;
          color: #fff;
          margin-right: 20px;

          &:hover {
            background-color: #e68500;
          }
        }

        &.btn-buy {
          width: 220px;
          background-color: #ff6b6b;
          color: #fff;

          &:hover {
            background-color: #ff5252;
          }
        }
      }
    }
  }

  .qr-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;

    .qr-content {
      width: 700px;
      background-color: #fff;
      border-radius: 20px;
      padding: 50px;
      position: relative;

      .qr-title {
        font-size: 38px;
        font-weight: 600;
        color: #333;
        text-align: center;
        margin-bottom: 40px;
      }

      .qr-code {
        display: flex;
        flex-direction: column;
        align-items: center;

        .qr-image {
          width: 350px;
          height: 350px;
          margin-bottom: 25px;

          .qr-placeholder {
            width: 100%;
            height: 100%;
            background-color: #fff;
            border: 1px solid #ddd;
            display: flex;
            align-items: center;
            justify-content: center;

            .qr-pattern {
              display: grid;
              grid-template-columns: repeat(8, 1fr);
              grid-template-rows: repeat(8, 1fr);
              gap: 2px;
              width: 240px;
              height: 240px;

              .qr-square {
                width: 100%;
                height: 100%;
                background-color: #f0f0f0;

                &.filled {
                  background-color: #000;
                }
              }
            }
          }
        }

        .qr-text {
          font-size: 28px;
          color: #666;
          text-align: center;
        }
      }

      .qr-close {
        position: absolute;
        top: 20px;
        right: 20px;
        width: 40px;
        height: 40px;
        font-size: 36px;
        color: #999;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border-radius: 50%;

        &:hover {
          background-color: #f0f0f0;
        }
      }
    }
  }

  .service-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;

    .service-content {
      width: 600px;
      background-color: #fff;
      border-radius: 20px;
      padding: 40px;
      position: relative;

      .service-title {
        font-size: 32px;
        font-weight: 600;
        color: #333;
        text-align: center;
        margin-bottom: 30px;
      }

      .service-info {
        .service-item {
          display: flex;
          align-items: center;
          margin-bottom: 20px;

          .iconfont {
            font-size: 36px;
            color: #0066cc;
            margin-right: 20px;
          }

          span {
            font-size: 24px;
            color: #333;
          }
        }
      }

      .service-close {
        position: absolute;
        top: 20px;
        right: 20px;
        width: 40px;
        height: 40px;
        font-size: 36px;
        color: #999;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border-radius: 50%;

        &:hover {
          background-color: #f0f0f0;
        }
      }
    }
  }

  .loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 400px;

    .loading-spinner {
      width: 50px;
      height: 50px;
      border: 4px solid #f3f3f3;
      border-top: 4px solid #0066cc;
      border-radius: 50%;
      animation: load 1s linear infinite;
      margin-bottom: 20px;
    }

    .loading-text {
      font-size: 24px;
      color: #666;
    }
  }
}
</style>
